import { useTranslation } from "react-i18next";
import type { LabReading } from "../types";
import { LabReadingListItem } from "./LabReadingListItem";

export interface LabPreviousReadingsListProps extends React.ComponentProps<"div"> {
  selectedReadingId?: string;
  onSelectReading?: (reading: LabReading) => void;
  sortedReadings: LabReading[];
}

export const LabPreviousReadingsList = ({
  selectedReadingId,
  onSelectReading,
  sortedReadings,
  className,
  ...props
}: LabPreviousReadingsListProps) => {
  const { t } = useTranslation("ui");

  return (
    <div data-slot="lab-previous-readings-list" className={className} {...props}>
      <p className="px-5 py-3 text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider border-b border-gray-100 dark:border-gray-800">
        {t("All Readings")}
      </p>
      <div className="divide-y divide-gray-50 dark:divide-gray-800">
        {sortedReadings.map((reading, i) => (
          <LabReadingListItem
            key={reading.id}
            reading={reading}
            isSelected={reading.id === selectedReadingId}
            isLatest={i === 0}
            onClick={() => onSelectReading?.(reading)}
          />
        ))}
      </div>
    </div>
  );
};
